import React, { useRef, useState } from "react";
import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetAllSPLCOffices from "./hooks/useGetAllSPLCOffices";
import DownloadButton from "../../../../components/DownloadButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
//import useGetDigitalAssetsReport from "./hooks/useGetDigitalAssetsReport";

interface SPLCOfficesReportProps {}
export const SPLCOfficesReport: React.FC<SPLCOfficesReportProps> = () => {
  const [exportData, setExportData] = useState([]);
  const { data: splcOffices, isLoading: splcOfficesLoading } =
    useGetAllSPLCOffices();

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);

  const tableRef = useRef<any>([]);

  interface IOsplcOffices {
    officeType: string;
    channelC: string;
    officeName: string;
    officeCode: string;
    storeNumber: string;
    salesTypeC: string;
    officeStatus: string;
    brandMarketingName: string;
    entityName: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    mondayStoreHours: string;
    tuesdayStoreHours: string;
    wednesdayStoreHours: string;
    thursdayStoreHours: string;
    fridayStoreHours: string;
    saturdayStoreHours: string;
    sundayStoreHours: string;
  }

  //For downloading table data
  const mapDataToExport = (data) => {
    setExportData(
      data?.map((splc: IOsplcOffices) => {
        return {
          Type: splc.officeType,
          Channel: splc.channelC,
          "Office Name": splc.officeName,
          "Office Code": splc.officeCode,
          "Corporate Office #": splc.storeNumber,
          "Sales Type": splc.salesTypeC,
          "Office Status": splc.officeStatus,
          Brand: splc.brandMarketingName,
          "Legal Entity": splc.entityName,
          Street: splc.address,
          City: splc.city,
          State: splc.state,
          "Zip Code": splc.zipCode,
          "Monday Office Hours": splc.mondayStoreHours,
          "Tuesday Office Hours": splc.tuesdayStoreHours,
          "Wednesday Office Hours": splc.wednesdayStoreHours,
          "Thursday Office Hours": splc.thursdayStoreHours,
          "Friday Office Hours": splc.fridayStoreHours,
          "Saturday Office Hours": splc.saturdayStoreHours,
          "Sunday Office Hours": splc.sundayStoreHours,
        };
      })
    );
  };

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "SPLCOfficesReport_" + dateTimeToday + ".csv",
    data: exportData,
  };
  const officeColumns = [
    { title: "Type", field: "officeType" },
    { title: "Channel", field: "channelC" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "SPLCOfficeReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Office Code", field: "officeCode" },
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Sales Type", field: "salesTypeC" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Brand", field: "brandMarketingName" },
    { title: "Legal Entity", field: "entityName" },
    { title: "Street", field: "address" },
    { title: "City", field: "city" },
    { title: "State", field: "state" },
    { title: "Zip Code", field: "zipCode" },
    { title: "Monday Office Hours", field: "mondayStoreHours" },
    { title: "Tuesday Office Hours", field: "tuesdayStoreHours" },
    { title: "Wednesday Office Hours", field: "wednesdayStoreHours" },
    { title: "Thursday Office Hours", field: "thursdayStoreHours" },
    { title: "Friday Office Hours", field: "fridayStoreHours" },
    { title: "Saturday Office Hours", field: "saturdayStoreHours" },
    { title: "Sunday Office Hours", field: "sundayStoreHours" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Accounts
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                SPLC Offices Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {
                  splcOffices?.filter((x) =>
                    user?.isFranchise && user?.isNonFranchise
                      ? true
                      : user?.isFranchise
                      ? x.officeType?.toLowerCase() === "franchise"
                      : x.officeType?.toLowerCase() !== "franchise"
                  ).length
                }
              </span>
            </div>
            <CSVLink className="" {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() =>
                  mapDataToExport(tableRef.current.dataManager.searchedData)
                }
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={splcOffices?.filter((x) =>
              user?.isFranchise && user?.isNonFranchise
                ? true
                : user?.isFranchise
                ? x.officeType?.toLowerCase() === "franchise"
                : x.officeType?.toLowerCase() !== "franchise"
            )}
            isLoading={splcOfficesLoading}
            columns={officeColumns}
            showTitle={false}
            showToolbar={true}
            toolbarSearch={true}
            searchFieldAlignment="left"
            tableRef={tableRef}
          />
        </div>
      </div>
    </div>
  );
};
